export const JOB_CHANGE_WILLINGNESS = [
  { name: '積極的に検討', value: 'positively_consideration' },
  { name: '検討中', value: 'consideration' },
  { name: 'いい求人があれば', value: 'passively_consideration' },
  { name: '検討していない', value: 'not_consideration' },
]
